module.exports = require('./viewerScript').viewerScript;
